import type { Lootbox, PlayerBonus, PlayerFreespin } from 'api/common';
import { BonusStage, LootboxStage } from 'api/common';
import { REWARD_GROUP_KEY_PATTERN } from '../constants';

type TReward = PlayerBonus | PlayerFreespin | Lootbox;

/** level order -> lootbox to open, or null when the reward is a plain bonus */
export type TIssuedRewards = ReadonlyMap<number, number | null>;

// lucky_moon_l3_reward -> 3
const getRewardOrder = ({ groupKey }: TReward): number | null => {
  const match = groupKey
    ? REWARD_GROUP_KEY_PATTERN.exec(groupKey.toLowerCase())
    : null;

  return match ? Number.parseInt(match[1], 10) : null;
};

const isWaiting = ({ stage }: TReward): boolean =>
  stage === BonusStage.Issued || stage === LootboxStage.Issued;

const isLootbox = (reward: TReward): reward is Lootbox => 'items' in reward;

/**
 * Levels whose reward has been issued and is still waiting for the player.
 * Several of them can pile up, since clearing a level does not activate the
 * bonus, and L6-L7 arrive as lootboxes that have to be opened.
 */
export const getIssuedRewards = (rewards: TReward[]): TIssuedRewards =>
  rewards.reduce<Map<number, number | null>>((issued, reward) => {
    const order = getRewardOrder(reward);

    if (order !== null && isWaiting(reward)) {
      issued.set(order, isLootbox(reward) ? reward.id : null);
    }

    return issued;
  }, new Map());
